const TemplateCart = {
  qtyThrottle: undefined,
  el: $("#woo-cart"),

  init() {
    this.events();
  },

  events() {
    TemplateCart.el.on("change", ".quantity input", function (e) {
      if (TemplateCart.qtyThrottle) {
        return;
      }

      const inputEl = $(this);

      TemplateCart.qtyThrottle = setTimeout(() => {
        TemplateCart.changeQuantity(inputEl);
        TemplateCart.qtyThrottle = undefined;
      }, 1000);
    });
  },

  changeQuantity(inputEl) {
    TemplateCart.el.addClass("cart--loading");

    const product_key = inputEl
      .closest("[data-product-key]")
      .attr("data-product-key");

    const product_qty = parseInt(inputEl.val());

    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        action: "handle_change_quantity",
        product_key,
        product_qty,
      },
    }).done((resp) => {
      TemplateCart.setCart(resp);
      TemplateCart.el.removeClass("cart--loading");
    });
  },

  /**
   * Render quickcart
   **/
  render() {
    TemplateCart.open();
    TemplateCart.el.html(
      '<div class="quick-cart-loader"><div class="spinner"></div></div>'
    );

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      if (response) {
        TemplateCart.loaded();
        TemplateCart.el.html(response);
      } else {
        TemplateCart.close();
      }
    });
  },

  /**
   * Set cart item values
   */
  setCart(cart) {
    for (let index = 0; index < cart.items.length; index++) {
      const item = cart.items[index];

      const cartItemEl = $(`[data-product-key="${item.key}"]`);

      if (item.has_discount) {
        cartItemEl.find(".price-before-discount").html(item.regular_sum);
        cartItemEl.find(".price-after-discount").html(item.total_price_sum);
      } else {
        cartItemEl.find(".price-after-discount").html(item.total_price_sum);
      }
      if (cartItemEl.find(".cart-item-price-unit").length) {
        cartItemEl.find(".cart-item-price-unit").html(item.price_unit);
      }
    }

    $(".cart-vat").html(cart.price_without_tax);
    $(".cart-vat-only").html(cart.taxes);
    $(".cart-total").html(cart.total);
  },
};
export default TemplateCart;
